module.exports = __webpack_public_path__ + "static/mBEDedOne-3c74b26eb9c2d368d9a3810fddd4475a.webp";